import { Divider, Space } from 'antd';
import moment from 'moment';
import React from 'react';
import LoginLogo from '@/assets/images/login/login_logo.react.svg?react';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { useReportPage } from '@/infrastructure/reporter/datong/report';
import { ExtraLogin } from '@/presentation/pages/login/extra-login';
import { LoginForm } from '@/presentation/pages/login/login-form';
import { LoginProvider } from '@/presentation/pages/login/use-login';
import styles from './index.module.scss';

const LoginPage = () => {
  useReportPage(PAGE_ID.login);

  return (
    <LoginProvider>
      <div className={styles.loginPage}>
        <div className={styles.left}>
          <Space direction={'vertical'} size={16} className={styles.container}>
            <div>
              <LoginLogo/>
            </div>
            <div className={styles.slogan}>提供专业的质量监控服务，帮助开发者及时发现并解决问题，打造高质量App。</div>
          </Space>
        </div>
        <div className={styles.right}>
          <div className={styles.loginContainer}>
            <div className={styles.loginForm}>
              <LoginForm />
              <ExtraLogin />
            </div>
          </div>
          <div className={styles.copyright}>
            <Space split={<Divider type="vertical" />}>
              <span>腾讯公司 版权所有</span>
              <span>Copyright © 1998 - {moment().year()} Tencent. All Rights Reserved.</span>
            </Space>
          </div>
        </div>
      </div>
    </LoginProvider>
  );
};

export default LoginPage;
